/**
 * Courtesy of this gentleman in StackOverflow
 * @see https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
 * @see http://www.xtf.dk/2011/08/center-new-popup-window-even-on.html
 *
 * @param url URL to be displayed
 * @param title title of new popup window
 * @param w desired width for the popup
 * @param h desired height for the popup
 * @constructor
 */
export default function (url, title, w, h) {
  // Fixes dual-screen position                         Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left; // eslint-disable-line
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top; // eslint-disable-line

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width; // eslint-disable-line
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height; // eslint-disable-line

  const left = ((width / 2) - (w / 2)) + dualScreenLeft;
  const top = ((height / 2) - (h / 2)) + dualScreenTop;
  const newWindow = window.open(url, title, `scrollbars=yes, width=${w}', height=${h}, top=${top}, left=${left}`);

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus();
  }
}
